import sha1 from "js-sha1";
import {typeUtil} from "@repo/lib-common";
import {objUtil} from "@repo/lib-common";
type StringOrUndefined=typeUtil.StringOrUndefined;
const isNullOrEmpty=objUtil.isNullOrEmpty;

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace hashUtil {
    export function hashSha1(sourceStr: string): StringOrUndefined {
        let hash: StringOrUndefined = undefined;
        if (isNullOrEmpty(sourceStr)) return hash;
        hash = sha1(sourceStr);
        return hash;
    }
}
